<template>
    <base-dialog :showDialog="showDialog">
        <template v-slot:body>
            <v-card dark>
                <v-card-title>
                    {{$t('titulos.selecaoAmbiente')}}
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="ambiente"
                        class="text-caption"
                        outlined
                        :placeholder="$t('labels.ambiente')"
                    >
                    </v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="red" @click="$emit('close')">
                        <span>{{$t('labels.fechar')}}</span>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="salvarAmbiente">
                        <span>{{$t('labels.salvar')}}</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </base-dialog>
</template>

<script>
import BaseDialog from '../../shared/base-dialog/BaseDialog.vue'
export default {
    components:{BaseDialog},
    data : () => {
        return {
            ambiente: '',
        }
    },
    props:{
        showDialog:{
            type: Boolean, 
            default: false,
            required: true
        }
    },
    methods:{
        salvarAmbiente(){
            this.$emit('salvarAmbiente', this.ambiente);
        }
    }
}
</script>
